import axios from "axios"

export const shareVideoUrlService = async (videoUrl, token, expires_in) => {
    const body = {
        "video_url": videoUrl,
        "token": token,
        "expires_in": expires_in*60
    }

    const url = "https://share.cvis.videri.ai/share/video"
    const headers = {
        'Content-Type': 'application/json',
    }
    try {
        const response = await axios.post(url, body, { headers: headers })
        console.warn(response)
        return response.data // Suponiendo que la respuesta tenga un campo `data` con los datos de usuario
    } catch (error) {
        console.warn(error);
    }
}